import { PLAN_PRICE, type PaidTier } from '@/api';
import type { Strings } from '@/str';
import type { PayT } from '@/strings/pay';

import { clock, type ExplainAudio } from './useExplainAudio';

export const KICK = 'text-t11 font-extrabold tracking-kicker text-faint uppercase';

export const fill = (s: string, map: Record<string, string>) =>
  Object.keys(map).reduce((a, k) => a.split(`{${k}}`).join(map[k]), s);

export const som = (n: number) => String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

export const planCta = (t: PayT, tier: PaidTier) =>
  `${fill(t.exp.proGo, { p: t.pay.plans[tier].name })} · ${som(PLAN_PRICE[tier])} ${t.pay.perMonth}`;

export const WAVE = [
  30, 55, 80, 45, 95, 60, 38, 70, 100, 52, 44, 88, 62, 35, 75, 58, 92, 48, 66, 40, 84, 54, 72, 46,
  60, 33,
];

export const audioGlyph = (a: ExplainAudio, mine: boolean): 'play' | '…' | '❙❙' =>
  mine && a.loading ? '…' : mine && a.playing ? '❙❙' : 'play';

export const audioTime = (a: ExplainAudio, duration: number, mine: boolean, t: Strings) =>
  mine && a.done ? t.exp.listened : `${clock(mine ? a.t : 0)} / ${clock(duration)}`;

export const showMini = (a: ExplainAudio, sheetOpen: boolean) =>
  !sheetOpen && a.track !== null && !a.hidden && (a.playing || a.t > 0);
